<div class="container">
  <div class="row">
    <button
      (click)="buttonClicked()"
      [class.multi]="options.length"
      [ngClass]="{
        primary: type === buttonState.PRIMARY,
        secondary: type === buttonState.SECONDARY,
        silent: type === buttonState.SILENT,
        destructive: type === buttonState.DESTRUCTIVE,
      }"
      class="button-general"
      [class.destructive]
      [disabled]="disabled"
    >
      <div class="content" [class.gap]="icon && text">
        @if (img) {
          <img [src]="img" class="icon" />
        }
        @if (icon) {
          <mat-icon class="material-icons-outlined icon" [class.filtered]="filteredState">{{ icon }}</mat-icon>
        }
        <p class="medium-bold">{{ (text | translate) || text }}</p>
      </div>
    </button>

    @if (options.length) {
      <button
        [disabled]="disabled"
        class="dropdown"
        [ngClass]="{
          'dropdown-primary': type === buttonState.PRIMARY,
          'dropdown-secondary': type === buttonState.SECONDARY,
        }"
        (click)="showDropdown($event)"
      >
        <mat-icon class="material-symbols-outlined"> arrow_drop_down </mat-icon>
      </button>
    }
  </div>

  @if (dropDownOpen && options.length) {
    <div class="dropdownList">
      @for (option of options; track option) {
        <div>
          <button class="button-general silent row" [class.gap]="option.icon && option.label" (click)="optionClicked(option)">
            @if (option.img) {
              <img class="material-icons-outlined icon" [src]="option.img" />
            }
            @if (option.icon) {
              <mat-icon class="material-icons-outlined icon">{{ option.icon }}</mat-icon>
            }
            <p class="medium-bold">{{ option.label | translate }}</p>
          </button>
        </div>
      }
    </div>
  }
</div>
